var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "el-dialog",
        {
          staticClass: "__pop-nutritional",
          attrs: {
            width: "450px",
            title: "证书门槛设置",
            top: "10vh",
            center: true,
            visible: _vm.isShow,
            "append-to-body": true,
          },
          on: {
            close: _vm.closePop,
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content-box" },
            [
              _c(
                "el-form",
                {
                  ref: "证书门槛设置表单",
                  attrs: {
                    size: "medium",
                    "label-position": "right",
                    model: _vm.formData,
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "用户手机号：",
                                prop: "phone",
                                "label-width": "110px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                  maxlength: "11",
                                  clearable: "",
                                  placeholder: "请输入手机号",
                                },
                                model: {
                                  value: _vm.formData.phone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "phone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.phone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "证书照片：",
                                prop: "thumb",
                                "label-width": "110px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "acea-row upLoadPicBox row-middle",
                                },
                                [
                                  _vm.formData.thumb
                                    ? _c(
                                        "div",
                                        { staticClass: "pictrue" },
                                        [
                                          _c("el-image", {
                                            staticClass: "image",
                                            attrs: {
                                              src: _vm.formData.thumb,
                                              "preview-src-list": [
                                                _vm.formData.thumb,
                                              ],
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass: "el-icon-error btndel",
                                            on: { click: _vm.delThumb },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "upLoad",
                                          on: { click: _vm.addThumb },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-camera cameraIconfont",
                                          }),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "tip-box" }, [
                                    _vm._v("（建议尺寸：648 x 470）"),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-box",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-item cancel-btn",
                  on: { click: _vm.closePop },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-item sure-btn",
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("确定")]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }